import React, { useEffect } from 'react';
import Layout from '../Layout/Layout';
import { makeStyles, Typography } from '@material-ui/core';
import ConfigSelector from './ConfigSelector/ConfigSelector';
import CountUp from 'react-countup';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import Fade from '@material-ui/core/Fade';

const useStyles = makeStyles(theme => ({
    MainWrapper : {
        display: 'flex',
        width: '80%',
        minWidth: '300px',
        margin: '0 auto',        
        top: 0, 
        justifyContent: 'center',
        alignItems: 'center',
        height: '90vh',       
        [theme.breakpoints.down('sm')]: {
            height: 'initial'
        }
    },

    CenterWrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            justifyContent: 'flex-start'
        }
    },

    IllustrationWrapper: {        
        maxWidth: '50%',
        '& img' : {
            width: '100%',
            maxWidth: '500px'
        },
        alignSelf: 'center',
        marginLeft: '120px',
        [theme.breakpoints.down('sm')]: {
            order: 0,
            maxWidth: 'initial',
            width: '100%',
            marginLeft: 'initial',
            paddingTop: theme.spacing(4)
        }
    },
   
    FormWrapper: {  
        width: '360px',
        maxWidth: '400px',
        display: 'flex',
        flexDirection: 'column',
        // margin: `${theme.spacing(5)}px auto 0`
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            padding: '0 15px',
            margin: '0 auto',
            order: 1,
            height: '100vh'
        }
    },        
    title: {
        width: '100%',
        //color: theme.palette.common.white,
        fontSize: '32px',
        fontWeight: 400,
        marginBottom: theme.spacing(3),        
        [theme.breakpoints.down('sm')]: {
            fontSize: '24px',
            marginTop: theme.spacing(3)        
        }
    }    
}))


export default withWidth()(function Home(props) {    
    const classes = useStyles();
    let [adsCount, setAdsCount] = React.useState(0);
    const [loading, setLoading] = React.useState(false);  
    const [showForm, setShowForm] = React.useState(false);        
    
    useEffect(() => {                 
        let dl = window.dataLayer;
        let dlObj = {
            'ruta': '/AgroadsPrecios/',
            'titulo': 'Home-Precios',
            'categoriaPagina': 'Home-Precios',            
            'event': 'pv'
        }
        dl.push(dlObj);

        setLoading(true) 
        fetch('https://www.agroads.com.ar/precios/api/es.asp?action=cantidadtotal')
        .then(res => res.json())
        .then(jsonRes => {
            setAdsCount(jsonRes.hits.total);
        })
        .catch(error => console.log(error))
        .finally(() => setLoading(false))   
        
        if (!isWidthUp('sm', props.width)) {
            setTimeout(() => {        
                setShowForm(true);
            }, 1400)

            setTimeout(()=>{
                window.scrollTo({top:360, left: 0, behavior: 'smooth' })            
            }, 1400)
        }
    }, [])
    
    let bgImgDesktop = 'https://static.aastatic.com.ar/img/precios/img-precios-escritorio.png';
    let bgImgMobile = 'https://static.aastatic.com.ar/img/precios/img-precios-movil.png';
    let referenceText = adsCount === 0 ? 'Referencia de precios' : (<span>Referencia de precios de Maquinaria Agrícola basada en <CountUp end={adsCount} duration={0.7} separator="." decimals={0} /> equipos</span>);

    return (
        <Layout loading={loading}>
            <div className={classes.MainWrapper}>
                <div className={classes.CenterWrapper}>
                    <Fade in={isWidthUp('sm', props.width) ? true : showForm} timeout={1000}>         
                        <div className={classes.FormWrapper}>   
                                <Typography className={classes.title}>{referenceText}</Typography>
                                <ConfigSelector setLoading={setLoading}/>                                                
                        </div>                
                    </Fade>
                    <div className={classes.IllustrationWrapper}>
                        <Fade in={true} timeout={800}>                            
                            <img src={isWidthUp('sm', props.width) ? bgImgDesktop : bgImgMobile} alt="Portada Agroads Precios" />                            
                        </Fade>                        
                    </div>
                </div>
            </div>
        </Layout>
    )
})
